<template>
    <ArticlePickerPane :multiple="false" :previewable="false" ref="picker" showStoreItems
        :itemValueKey="'ArticleNumber'" :machineModelId="machineModelId" :pk="pk" :closeFunc="close"
        :closeOnSelect="false" @select="arr => select(arr)">

        <template v-slot:overlay>
            <OrderDetailForm v-if="articleNumber" :createFunc="createFunc">
                <template v-slot:toolbar-content>
                    <v-btn icon small class="mr-2" @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h4 class="mt-1 primary--text linklike" @click="back()">
                        {{ $t("servicesystem.common_objects.commonterms.add_article") }}</h4>
                    <v-btn icon small class="mr-2" @click="back()">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                    <h4 class="mt-1">{{ articleNumber }}</h4>
                </template>
            </OrderDetailForm>
        </template>

    </ArticlePickerPane>
</template>


<script>
import ArticlePickerPane from "@/views/pim/articles/ArticlePickerPane.vue";
import OrderDetailForm from "./OrderDetailForm.vue";

export default {
    name: "CreateOrderDetailMenu",
    props: {
        createFunc: Function,
    },
    components: {
        ArticlePickerPane,
        OrderDetailForm,
    },

    data() {
        return {
            pk: 'OD-PP-'
        };
    },

    methods: {
        select(selectionFilter) {
            this.articleNumber = selectionFilter.PrependItemIdList[0];
            //console.log("Selected article:", this.articleNumber, selectionFilter);
            this.$refs.picker.clearSelection();
        },

        back() {
            this.articleNumber = null;
        },

        close() {
            this.$router.push({
                name: "ViewJobOrder",
                params: { ...this.$route.params, filter: this.$route.params.filter, jobId: this.$route.params.jobId, articleNumber: undefined},
                query: this.$route.query,
            });
        },
    },

    computed: {
        articleNumber: {
            get() {
                return this.$route.params.articleNumber;
            },
            set(value) {
                const route = Object.assign({}, this.$route);
                route.params.articleNumber = value;
                this.$router.push(route);
            },
        },

        subjobId() {
            return this.$route.params.machineJobId;
        },

        subjob() {
            var childjobs = this.$store.getters["JobHub/Subjobs"];
            return childjobs?.find(x => x.Id == this.subjobId);
        },

        machineModelId() {
            //console.log('childjob', this.subjobId, this.subjob)
            return this.subjob?.Machine?.MachineModel?.Id
        },
    },

    watch: {},
}
</script>


<style>
.linklike:hover {
    cursor: pointer !important;
    text-decoration: underline !important;
}
</style>
